import { ForwardedRef, forwardRef, memo } from 'react';
import { Input, TextInput } from '@betty/moonlight';
import { DefaultFieldTypes } from './DefaultField.types';

function DefaultField(
  { value, onValue, ...rest }: DefaultFieldTypes,
  ref: ForwardedRef<TextInput>,
) {
  const valueType = typeof value;
  if (!valueType.match(/string|number/)) {
    return null;
  }

  const stringValue = String(value as string | number);

  return (
    <Input value={stringValue} ref={ref} onChangeText={onValue} {...rest} />
  );
}

export default memo(forwardRef(DefaultField));
